import React from 'react';
import PropTypes from 'prop-types';

const SubscriptionIcon = ({ size = '32px', fill = '#000' }) => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      height={size}
      width={size}
    >
      <g>
        <g>
          <path
            d="M389.513,87.422c0-12.012-4.688-23.32-13.184-31.816l-42.422-42.422C325.529,4.805,313.636,0,301.8,0h-2.578v90h90.292
			L389.513,87.422L389.513,87.422z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M273.937,309.537c2.871-8.716,7.881-16.831,14.414-23.408l101.562-101.153V120h-105.4c-8.291,0-14.513-6.709-14.513-15V0
			H45C20.186,0,0,20.186,0,45v422c0,24.814,20.186,45,45,45h299.513c24.814,0,45.4-20.186,45.4-45V355.049l-16.484,16.084
			c-6.679,6.621-14.501,11.44-23.32,14.385l-47.695,15.923l-7.266,0.396c-12.012,0-23.379-5.845-30.439-15.63
			c-7.002-9.741-8.906-22.368-5.098-33.779L273.937,309.537z M75,270h149.513c8.291,0,15,6.709,15,15c0,8.291-6.709,15-15,15H75
			c-8.291,0-15-6.709-15-15C60,276.709,66.709,270,75,270z M60,225c0-8.291,6.709-15,15-15h149.513c8.291,0,15,6.709,15,15
			s-6.709,15-15,15H75C66.709,240,60,233.291,60,225z M60,345c0-8.291,6.709-15,15-15h149.513c8.291,0,15,6.709,15,15
			c0,8.291-6.709,15-15,15H75C66.709,360,60,353.291,60,345z M284.513,420c8.291,0,15,6.709,15,15c0,8.291-6.708,15-15,15h-90
			c-8.291,0-15-6.709-15-15c0-8.291,6.709-15,15-15H284.513z M75,180c-8.291,0-15-6.709-15-15s6.709-15,15-15h209.513
			c8.291,0,15,6.709,15,15s-6.709,15-15,15H75z"
          />
        </g>
      </g>
      <g>
        <g>
          <path d="M301.111,322.808l-13.05,39.151c-1.956,5.865,3.625,11.444,9.49,9.485l39.128-13.068L301.111,322.808z" />
        </g>
      </g>
      <g>
        <g>
          <path d="M417.609,199.307l-98.789,98.789l42.605,42.605c22.328-22.332,65.773-65.783,98.784-98.794L417.609,199.307z" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M503.185,156.284c-5.273-5.303-13.037-8.335-21.27-8.335c-8.233,0-15.996,3.032-21.299,8.35l-21.797,21.797l42.598,42.598
			c11.933-11.934,20.181-20.182,21.799-21.799C514.933,187.16,514.932,168.046,503.185,156.284z"
          />
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              d="M503.215,198.896c0.001,0,0.001-0.001,0.002-0.002c0.038-0.038,0.055-0.055,0.086-0.086
				C503.272,198.84,503.255,198.857,503.215,198.896z"
            />
            <path d="M503.303,198.808c0.048-0.048,0.104-0.104,0.133-0.133C503.406,198.705,503.351,198.76,503.303,198.808z" />
            <path d="M503.436,198.675C503.533,198.578,503.535,198.576,503.436,198.675L503.436,198.675z" />
          </g>
        </g>
      </g>
    </svg>
  );
};

SubscriptionIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

export default SubscriptionIcon;
